import React from "react";
import {guestTypes} from "configuration/constants";
import {useTheme} from "connectui/theme/ThemeProvider";
import DropDownSelect from "connectui/component/input/dropdown/DropDownSelect";
import ChipDropDownBase from "connectui/component/input/dropdown/base/ChipDropDownBase";
import FlexContainer from "connectui/component/layout/FlexContainer";
import ICONS from "connectui/icons/iconMap";
import SvgIcon from "connectui/component/display/SvgIcon";
import Text from "connectui/component/display/Text";
import {useTranslation} from "react-i18next";

const guestTypeIcons = {
  guest: ICONS.user,
  owner: ICONS["home-owner"],
  maintenance: ICONS.tool,
  cleaner: ICONS.clean,
};

const GuestTypeSelector = ({selected, compact, onChange}) => {
  const {theme} = useTheme();
  const {t} = useTranslation();

  return (
    <DropDownSelect
      dropDownBase={ChipDropDownBase}
      selected={selected}
      label={
        <FlexContainer alignItems="center" gap={theme.spacing(1)}>
          {!!guestTypeIcons[selected] && (
            <SvgIcon
              component={guestTypeIcons[selected]}
              sx={{
                width: "14px",
                height: "14px",
                color: theme.colors.textSecondary,
                display: "flex",
              }}
            />
          )}
          {!compact && (
            <Text
              variant="textSM"
              weight="medium"
              color="gray700"
              sx={{textTransform: "capitalize"}}
            >
              {t(`inbox.conversations.header.guest-type.${selected}`)}
            </Text>
          )}
        </FlexContainer>
      }
      sx={{
        label: {
          padding: theme.spacing(1, 3),
          backgroundColor: theme.colors.gray100,
          "&:hover": {backgroundColor: theme.colors.gray200},
        },
      }}
      onChange={onChange}
    >
      {guestTypes.map((type) => (
        <FlexContainer
          key={type}
          value={type}
          alignItems="center"
          gap={theme.spacing(2)}
        >
          {!!guestTypeIcons[type] && (
            <SvgIcon
              component={guestTypeIcons[type]}
              sx={{
                width: "20px",
                height: "20px",
                color: theme.colors.textSecondary,
                display: "flex",
              }}
            />
          )}
          <Text
            variant="textMD"
            weight="medium"
            sx={{textTransform: "capitalize"}}
          >
            {t(`inbox.conversations.header.guest-type.${type}`)}
          </Text>
        </FlexContainer>
      ))}
    </DropDownSelect>
  );
};

export default GuestTypeSelector;
